import keymirror from "../utils/keymirror";

export const PostConstants = keymirror(
    {
        NEW_POST: null,
        UPDATE_POST: null,
        SUBMIT_POST: null,
        SUBMIT_POST_SUCCESS: null,
        SUBMIT_POST_FAILURE: null,
        CLOSE_POST: null,

        TOGGLE_POST_REACTION: null,
        TOGGLE_POST_REACTION_SUCCESS: null,
        TOGGLE_POST_REACTION_FAILURE: null,

        EDIT_POST: null,
        EDIT_POST_SUCCESS: null,
        EDIT_POST_FAILURE: null,

        DELETE_POST: null,
        DELETE_POST_SUCCESS: null,
        DELETE_POST_FAILURE: null,

        REPORT_POST: null,
        REPORT_POST_SUCCESS: null,
        REPORT_POST_FAILURE: null,

        COPY_LINK: null
    },
    "post"
);



// WEBPACK FOOTER //
// ./src/constants/post.constants.js